<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <loading-provider :loading="loading">
      <template v-if="!reserveReady">
        <no-product-page />
      </template>
      <div v-else-if="reservationActivated">
        <div class="mt-4">
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="black"
            style="background: transparent"
          >
            <v-tab>{{ $t('overview') }}</v-tab>
            <v-tab>{{ $t('DeskManagement') }}</v-tab>
            <v-tab>{{ $t('RuleManagement') }}</v-tab>
            <v-tab>{{ $t('openTime') }}</v-tab>
            <v-tab>{{ $t('SpecialOpeningTimes') }}</v-tab>
            <v-tab v-if="advanced">
              特殊价格
            </v-tab>
            <v-tab v-if="advanced">
              套餐详情
            </v-tab>
          </v-tabs>
          <v-divider />
        </div>
        <v-tabs-items
          v-model="tab"
          class="mt-4"
          style="background: transparent"
        >
          <v-tab-item>
            <open-reserve :info="reservationActivated" />
          </v-tab-item>
          <v-tab-item :disabled="!reservationActivated">
            <useful-reserve-table />
          </v-tab-item>
          <v-tab-item :disabled="!reservationActivated">
            <table-rules />
          </v-tab-item>
          <v-tab-item :disabled="!reservationActivated">
            <reservation-open-time />
            <date-as-weekday class="mt-8" />
          </v-tab-item>
          <v-tab-item :disabled="!reservationActivated">
            <special-closing-time />
          </v-tab-item>
          <v-tab-item
            v-if="advanced"
            :disabled="!reservationActivated"
          >
            <special-price />
          </v-tab-item>
          <v-tab-item
            v-if="advanced"
            :disabled="!reservationActivated"
          >
            <price-combo />
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div v-else>
        <not-active-page
          :product-name="$t('ReservationSystem')"
          @click="activeDialog = true"
        />
      </div>
    </loading-provider>
    <v-dialog
      v-model="activeDialog"
      max-width="500px"
      persistent
    >
      <base-form
        :editing-object="reserveStatus"
        :schema="schemas"
        @close="activeDialog=false"
        @submit="saveUserInfo"
      >
        <div>{{ $t('PlannedSettings') }}</div>
        <template #subtitle>
          {{ $t('PlannedSettingsHint') }}
        </template>
      </base-form>
    </v-dialog>
  </div>
</template>

<script>
import OpenReserve from '@/views/AadenPages/settings/reserveSetting/reserveDashboard/OpenReserve.vue'
import UsefulReserveTable from '@/views/AadenPages/settings/reserveSetting/UsefulReserveTable'
import TableRules from '@/views/AadenPages/settings/reserveSetting/tableRule/TableRules.vue'
import NoProductPage from '@/views/widget/commonLogic/NoProductPage'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import ReservationOpenTime from '@/views/AadenPages/settings/reserveSetting/openTime/ReservationOpenTime.vue'
import DateAsWeekday from '@/views/AadenPages/settings/reserveSetting/openTime/DateAsWeekday.vue'
import SpecialClosingTime from '@/views/AadenPages/settings/reserveSetting/SpecialClosingTime.vue'
import NotActivePage from '@/views/SaaS/widget/NotActivePage.vue'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import {
  activeReservation,
  checkReservationStatus,
  getReservationUserCloudList
} from '@/model/dataLayer/api/newReservation/reservation'
import SpecialPrice from '@/views/AadenPages/settings/reserveSetting/SpecialPrice.vue'
import PriceCombo from '@/views/AadenPages/settings/reserveSetting/PriceCombo.vue'

export default {
  name: 'ReserveIndex',
  components: {
    DateAsWeekday,
    PriceCombo,
    SpecialPrice,
    BaseForm,
    NotActivePage,
    SpecialClosingTime,
    ReservationOpenTime,
    LoadingProvider,
    NoProductPage,
    TableRules,
    UsefulReserveTable,
    OpenReserve
  },
  data () {
    return {
      advanced: false,
      tab: null,
      reserveReady: false,
      activeDialog: false,
      reservationActivated: false,
      reserveStatus: {
        subdomainName: '',
        mapUrl: ''
      },
      openUserList: null,
      loading: true
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'subDomainName',
          name: 'SubdomainLink',
          componentProps: {
            rules: [
              v => !!v || this.$t('hostCantEmpty'),
              v => !this.openUserList.find(
                it => it.subDomainName !== this.reserveStatus.subDomainName && it.subDomainName === v) ||
                  this.$t('thisHostnameAlreadyUse')
            ]
          }
        },
        {
          key: 'mapUrl',
          name: 'GoogleMapsLink'
        }
      ]
    }
  },
  methods: {
    async saveUserInfo (info) {
      await activeReservation(info)
      this.activeDialog = false
      await this.reload()
    },
    async reload () {
      try {
        this.loading = true
        const result = await checkReservationStatus()
        this.openUserList = await getReservationUserCloudList()
        this.reserveReady = result.basic
        this.reservationActivated = result.setting
        this.advanced = result.advanced
      } catch (e) {

      } finally {
        this.loading = false
      }
    }
  },
  async mounted () {
    await this.reload()
  }

}
</script>

<style scoped>
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
</style>
